import Slider from '@carvana/showroom-forms/Slider';
import type { ownProps as SliderProps } from '@carvana/showroom-forms/Slider/Slider';
import { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import SearchSource from '~/constants/SearchSource';
import SearchEventsDataContext from '~/contexts/SearchEventsDataContext';

function useSlideSizeCalculationTrigger(show: boolean) {
  const [trigger, setTrigger] = useState(0);

  useEffect(() => {
    if (show) setTrigger(Date.now());
  }, [show]);

  return trigger;
}

const StyledSlider = styled(Slider)`
  .sliderHeader {
    display: grid;
    grid-template-columns: 1fr auto;

    .sliderHeader__input-dual:first-child {
      align-items: center;
      display: grid;
      grid-template-columns: 1fr auto 20px;

      &::after {
        content: '-';
        text-align: center;
      }

      .sliderHeader__label {
        margin-right: 8px;
      }
    }

    .sliderHeader__input-dual:last-child {
      display: grid;
      grid-template-columns: 1fr auto;
    }

    .sliderHeader__label {
      margin: 0;
      text-align: left;
      text-transform: var(--label-text-transform, uppercase);
    }

    .input__caption {
      display: none;
    }

    input {
      color: var(--cvna-color-blue-2);
      font-weight: normal;
      padding: 0 8px;
      width: var(--input-width, 105px);
    }
  }
`;

type OwnProps = SliderProps & {
  inputWidth?: string;
  isShowing: boolean;
  labelTextTransform?: string;
};

export default function RangeSlider({
  inputWidth,
  isShowing,
  labelTextTransform,
  onUpdate,
  ...props
}: OwnProps) {
  const { setSearchSource } = useContext(SearchEventsDataContext);
  const sizeCalculationTrigger = useSlideSizeCalculationTrigger(isShowing);

  const onUpdateHandler = (v: number[] | undefined) => {
    setSearchSource(SearchSource.Facet);
    if (onUpdate) onUpdate(v);
  };

  return (
    <div
      style={{
        ['--input-width' as string]: inputWidth,
        ['--label-text-transform' as string]: labelTextTransform
      }}
    >
      <StyledSlider
        sizeCalculationTrigger={sizeCalculationTrigger}
        onUpdate={onUpdateHandler}
        {...props}
      />
    </div>
  );
}
